export default __webpack_public_path__ + "static/logo_csa@2x-e8515e482fa3b038acf79a69671ad7f0.png";